import { db } from '../firebase';
import { getBackendError } from 'common/utils';

const questionMapper = (documentSnapshot) => {
  const { name, lead, categoryUid, subcategoryUid, image, typeImage } = documentSnapshot.data();

  return {
    id: documentSnapshot.id,
    categoryUid,
    subcategoryUid,
    image,
    name,
    lead,
    typeImage: typeImage ? typeImage : ''  
  };
};

const questionListMapper = (docs) => {
  return docs.map((documentSnapshot) => questionMapper(documentSnapshot));
};

export const getQuestionsList = async () => {
  return new Promise((resolve, reject) => {
    db
      .collection('question')
      .orderBy('name.ru')
      .get()
      .then((querySnapshot) => resolve(questionListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateQuestion = async (
  id,
  categoryUid,
  subcategoryUid,
  nameEn,
  nameRu,
  nameUk,
  namePl,
  nameIt,
  nameEs,
  namePt,
  leadEn,
  leadRu,
  leadUk,
  leadPl,
  leadIt,
  leadEs,
  leadPt,
  typeImage,
  ) => {
  return new Promise((resolve, reject) => {
    db
      .collection('question')
      .doc(id)
      .update({
        categoryUid,
        subcategoryUid,
        name: {
          en: nameEn,
          ru: nameRu,
          uk: nameUk,
          pl: namePl ? namePl : '',
          it: nameIt ? nameIt : '',
          es: nameEs ? nameEs : '',
          pt: namePt ? namePt : '',
        },
        lead: {
          en: leadEn,
          ru: leadRu,
          uk: leadUk,
          pl: leadPl ? leadPl : '',
          it: leadIt ? leadIt : '',
          es: leadEs ? leadEs : '',
          pt: leadPt ? leadPt : '',
        },
        typeImage: typeImage ? typeImage : '',
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const getQuestionItem = async (id) => {
  return new Promise((resolve, reject) => {
    db
      .collection('question')
      .doc(id)
      .get()
      .then((querySnapshot) => {
        const { name, lead, categoryUid, subcategoryUid, image, typeImage } = querySnapshot.data();
        const obj = {
          id: querySnapshot.id,
          categoryUid,
          subcategoryUid,
          image,
          name,
          lead,
          typeImage,
        };
        resolve(obj);
      })
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateQuestionImage = (id, image) => {
  return new Promise((resolve, reject) => {
    db
      .collection('question')
      .doc(id)
      .update({
        image
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const createQuestion = (
  categoryUid,
  subcategoryUid,
  nameEn,
  nameRu,
  nameUk,
  namePl,
  nameIt,
  nameEs,
  namePt,
  leadEn,
  leadRu,
  leadUk,
  leadPl,
  leadIt,
  leadEs,
  leadPt,
) => {
  return new Promise((resolve, reject) => {
    db
      .collection('question')
      .add({
        categoryUid,
        subcategoryUid,
        name: {
          en: nameEn,
          ru: nameRu,
          uk: nameUk,
          it: nameIt,
          pl: namePl,
          es: nameEs,
          pt: namePt
        },
        lead: {
          en: leadEn,
          ru: leadRu,
          uk: leadUk,
          it: leadIt,
          pl: leadPl,
          es: leadEs,
          pt: leadPt,
        },
        image: '',
        typeImage: ''
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};
